export const FechaOperacionPedimentoEnum = {
    Entrada: "1",
    Pago: "2",
    Extraccion: "3",
    Presentacion: "5",
    ImpEUACAN: "6",
    Original: "7",
};

export const fechaOperacionPedimento = [
    {
        clave: FechaOperacionPedimentoEnum.Entrada,
        descripcion: "Entrada",
    },
    {
        clave: FechaOperacionPedimentoEnum.Pago,
        descripcion: "Pago",
    },
    {
        clave: FechaOperacionPedimentoEnum.Extraccion,
        descripcion: "Extracción",
    },
    {
        clave: FechaOperacionPedimentoEnum.Presentacion,
        descripcion: "Presentación",
    },
    {
        clave: FechaOperacionPedimentoEnum.ImpEUACAN,
        descripcion: "IMP EUA/CAN",
    },
    {
        clave: FechaOperacionPedimentoEnum.Original,
        descripcion: "Original",
    },
];

export const fechaOperacionPedimentoImportacion = [
    ...fechaOperacionPedimento.filter(
        (itm) => itm.clave === FechaOperacionPedimentoEnum.Pago || itm.clave === FechaOperacionPedimentoEnum.Entrada,
    ),
];

export const fechaOperacionPedimentoExportacion = [
    ...fechaOperacionPedimento.filter(
        (itm) =>
            itm.clave === FechaOperacionPedimentoEnum.Pago || itm.clave === FechaOperacionPedimentoEnum.Presentacion,
    ),
];
